export default "__VITE_ASSET__BK5TKsjz__"